/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export class ErrorModel {
  severity: string | undefined = undefined;
  message: string | undefined = undefined;
  source?: string;
  detail?: string;
  field?: string;
  success? : boolean;

  constructor(severity: string, message: string, source?: string, detail?: string, field?: string, success? :boolean) {
    this.severity = severity;
    this.message = message;
    this.source = source;
    this.detail = detail;
    this.field = field;
    this.success = success;
  }
}
